/* eslint-disable @typescript-eslint/naming-convention */
import { JobDtoType } from '../index';
import { JobType } from '../../../api/jobs.dao';

export type BlueprintJobUserInfo = {
    email: string;
};

export type BlueprintJobMixpanelProperties = {
    'Event ID': string;
    'User Email': string;
    'JSON Response': Record<string, unknown>;
};

const BLUEPRINT_JOB_EVENT_NAME_MAP = new Map<JobType, string>([
    [JobType.EventBlueprintTrigger, 'Event Blueprint - OE Central'],
    [JobType.MeetingBlueprintTrigger, 'Meeting Blueprint - OE Central'],
    [JobType.GenerateConnectionsBlueprintTrigger, 'Connection Blueprint - OE Central'],
]);

type BlueprintEventIdSource = {
    eventId?: number;
};

export class BlueprintJobMixpanelMapper {
    public static isBlueprintJob(jobType: JobType): boolean {
        return BLUEPRINT_JOB_EVENT_NAME_MAP.has(jobType);
    }

    public static getEventName(jobType: JobType): string {
        return BLUEPRINT_JOB_EVENT_NAME_MAP.get(jobType) ?? '';
    }

    public static resolveEventId(job: JobDtoType): number | undefined {
        const fromDetails = (job.jobDetails as BlueprintEventIdSource)?.eventId;
        if (fromDetails != null) {
            return fromDetails;
        }

        const fromResult = (job.result as BlueprintEventIdSource | null | undefined)?.eventId;
        if (fromResult != null) {
            return fromResult;
        }

        return undefined;
    }

    public static toMixpanelProperties(job: JobDtoType, user: BlueprintJobUserInfo): BlueprintJobMixpanelProperties {
        const eventId = BlueprintJobMixpanelMapper.resolveEventId(job);

        return {
            'Event ID': eventId != null ? String(eventId) : '',
            'User Email': user.email,
            'JSON Response': BlueprintJobMixpanelMapper.buildJsonResponse(job),
        };
    }

    private static buildJsonResponse(job: JobDtoType): Record<string, unknown> {
        return {
            jobId: job.jobId,
            jobType: job.jobType,
            jobStatus: job.jobStatus,
            jobDetails: job.jobDetails,
            result: job.result,
        };
    }
}
